
































import Vue from 'vue';
import { assignActivation } from '@/api/school';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class Allot extends Vue {
  private dialogVisible = false
  private selected = [] // 总校激活码列表
  private orgInfo_last = {}
  private orgId = ''
  private name = ''

  @Prop({
    type: Array,
    default: () => []
  })
  list!: any;
  @Prop({
    type: Object,
    default() {
      return {
        id: '',
        name: '',
        status: '',
        cuStomerType: '',
        contactname: '',
        contactphone: '',
        adminemail: '',
        address: '',
        surplusCoursePackage: '',
        totalCoursePackage: '',
        teacherLimit: '',
        bindCount: '' // 剩余激活码数量
      };
    }
  })
  orgInfo!: any;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: any;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getList!: any;

  @Watch("orgInfo")
  infoChange (newVal: Object, oldVal: Object) {
    this.orgId = (newVal as any).id
    this.name = (newVal as any).name
    // console.log(`${this.orgId} - ${this.name}`)
  }


  handleSelectionChange(val: any) {
    this.selected = val
  }
  handleClose() {
    this.dialogVisible = false
  }
  async onSubmit() {
    try {
      let selected: any = this.selected
      let idArr = []
      for (let i = 0; i < selected.length; i++) {
        idArr.push(selected[i].id)
      }
      let idStr = idArr.join(',')
      // let orgId = (this.orgInfo_last as any).id
      let params = {
        orgId: this.orgId,
        orgName: this.name,
        activationId: idStr
      }
      console.log(params)
      await assignActivation(params)
      this.getData(this.orgId)
      this.getList() // 刷新列表数据
      this.$message.success('分配成功')
    } catch (err) {
      this.$message.error(err.message)
    }
    // this.count = 0
    this.dialogVisible = false
  }

}

